import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import {
  betAndFancyLocksCricketAPI,
  getBetLockUsersCricketAPI,
} from "../../../service/cricket";
import {
  betAndFancyLocksSoccerAPI,
  betAndFancyLocksTennisAPI,
  getBetLockUsersSoccerAPI,
  getBetLockUsersTennisAPI,
} from "../../../service/soccer&tennis";

export default function BetsLock({ eventId, isOpen, onClose, gameType }) {
  const [userBook, setUserBook] = React.useState({});
  const toast = useToast({ position: "top" });
  const [rows, setRows] = React.useState([]);
  const [transactionPassword, setTransactionPassword] = React.useState("");
  const getBetLockUsers = async () => {
    var response_;
    if (gameType == "cricket") {
      const { response } = await getBetLockUsersCricketAPI(eventId);
      response_ = response;
    } else if (gameType == "soccer") {
      const { response } = await getBetLockUsersSoccerAPI(eventId);
      response_ = response;
    } else {
      const { response } = await getBetLockUsersTennisAPI(eventId);
      response_ = response;
    }
    const data = Array.isArray(response_?.data) ? response_.data : [];
    setRows(data);
    setUserBook(data);
  };
  useEffect(() => {
    if (eventId) {
      getBetLockUsers();
    }
  }, [eventId, isOpen]);
  const changeBetLockStatus = async (userId, value, rows_) => {
    let payload = {};

    if (isOpen == "fancylockuserwise") {
      if (value) {
        payload.fancyLockedUsers = rows
          .filter((row) => row.fancyLock)
          .map((row) => row.userId);
        payload.fancyLockedUsers.push(userId);
        payload.isAdd = true;
      } else {
        payload.fancyLockedUsers = [userId];
        payload.isAdd = false;
      }
    } else {
      if (value) {
        payload.betLockedUsers = rows
          .filter((row) => row.betLock)
          .map((row) => row.userId);
        payload.betLockedUsers.push(userId);
        payload.isAdd = true;
      } else {
        payload.betLockedUsers = [userId];
        payload.isAdd = false;
      }
    }
    if (!transactionPassword.trim()) return;
    payload.transactionPassword = transactionPassword;
    if (gameType === "cricket") payload.cricketId = eventId;
    else payload.gameId = eventId;

    var code;
    if (gameType == "cricket") {
      const { response, code: code_ } = await betAndFancyLocksCricketAPI(
        payload
      );
      code = code_;
    } else if (gameType == "soccer") {
      payload.gameId = eventId;
      const { response, code: code_ } = await betAndFancyLocksSoccerAPI(
        payload
      );
      code = code_;
    } else {
      payload.gameId = eventId;
      const { response, code: code_ } = await betAndFancyLocksTennisAPI(
        payload
      );
      code = code_;
    }
    if (code == 200) {
      await getBetLockUsers();
      toast({
        title: "Success",
        description: "Bet Lock Status Changed",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
      setTransactionPassword("");
    } else {
      toast({ title: "Unable to change lock status", description: "The transaction password or user lock is invalid.", status: "error", duration: 2500 });
    }
  };
  return (
    <div className="modal fade show d-block" role="dialog" aria-modal="true" style={{ backgroundColor: "rgba(0, 0, 0, 0.55)" }}>
      <div className="modal-dialog modal-md" style={{ margin: "20px auto 0" }}>
        <div className="modal-content">
          <header className="modal-header">
            <h5 className="modal-title">
            {isOpen == "fancylockuserwise" ? "Fancy Lock" : "Bet Lock"}
            </h5>
            <button type="button" aria-label="Close" className="close" onClick={onClose}>×</button>
          </header>
          <div className="modal-body">
            <div className="row">
              <div className="col-6" />
              <div className="col-6">
            <FormControl mb={5}>
              <Input type="password" name="ulockmpass" placeholder="Transaction Code" value={transactionPassword} onChange={(e) => setTransactionPassword(e.target.value)} />
            </FormControl>
              </div>
            </div>
            <div className="table-responsive">
            <table className="table table-bordered" style={{ marginBottom: 0 }}>
              <thead><tr><th style={{ width: "55px" }}></th><th>All Account</th></tr></thead>
              <tbody>
                {rows.map((row) => {
                  const locked = isOpen == "fancylockuserwise" ? row.fancyLock : row.betLock;
                  return <tr key={row.userId}>
                    <td style={{ width: "55px" }}>
                      <button
                        type="button"
                        aria-label={`Lock ${row.userName}`}
                        onClick={() => {
                          if (!transactionPassword.trim()) {
                            toast({ title: "Transaction Code required", description: "Enter the transaction code first.", status: "error", duration: 2500, isClosable: true });
                            return;
                          }
                          changeBetLockStatus(row.userId, !locked, rows);
                        }}
                        style={{
                          width: "22px", height: "22px", padding: 0,
                          border: "2px solid #222", borderRadius: "3px",
                          backgroundColor: "#000",
                          color: locked ? "#fff" : "transparent", fontSize: "16px", fontWeight: "700", lineHeight: "16px",
                          cursor: "pointer",
                        }}
                      >{locked ? "✓" : ""}</button>
                    </td>
                    <td>{row.userName}</td>
                  </tr>;
                })}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
